export interface Usuario {
    id?: number;
    name: string;
    username: string;
    email: string;
    password?: string;
    tipo_id: number;
    gestion_camiones: boolean;
    activo: boolean;
}

export interface Perfil {
    id: number;
    name: string;
    username: string;
    email: string;
    password_actual?: string;
    password?: string;
    password_confirmation?: string;
}

export const CONFIG = {
    titulos: {
        nombre: 'Usuario',
        general: 'Listado de Usuarios',
        descrip: '',
        crear: 'Crear Usuario',
        editar: 'Editar Usuario',
        ver: 'Ver Usuario'
    },
    mensajes: {
        messageError: false,
        crear: {
            cerrar: false,
            pregunta: 'Seguro de guardar el usuario.',
            respuesta_ok: 'Usuario guardado.'
        },
        editar: {
            cerrar: false,
            pregunta: 'Seguro de guardar el usuario.',
            respuesta_ok: 'Usuario guardado.'
        },
        eliminar: {
            cerrar: false,
            pregunta: 'Seguro de eliminar el usuario.',
            respuesta_ok: 'Usuario eliminado.'
        },
        salir: {
            activo: true,
            pregunta: 'Seguro de salir.'
        }
    },
    campos: {
        id: {
            label: '',
            list: 'ID',
            help: ''
        },
        name: {
            label: 'Nombre',
            list: 'Nombre',
            help: ''
        },
        username: {
            label: 'Usuario',
            list: 'Usuario',
            help: ''
        },
        email: {
            label: 'E-Mail',
            list: 'E-Mail',
            help: ''
        },
        password: {
            label: 'Contraseña',
            list: 'Contraseña',
            help: ''
        },
        tipo_id: {
            label: 'Tipo',
            list: 'Tipo',
            help: ''
        },
        gestion_camiones: {
            label: 'Gestión de Camiones',
            list: 'Gestión de Camiones',
            help: ''
        },
        activo: {
            label: 'Estado',
            list: 'Estado',
            help: ''
        }
    },
    campos_perfil: {
        id: {
            label: '',
            list: 'ID',
            help: ''
        },
        name: {
            label: 'Nombre',
            list: 'Nombre',
            help: ''
        },
        username: {
            label: 'Nombre de Usuario',
            list: 'Nombre de Usuario',
            help: ''
        },
        email: {
            label: 'E-Mail de Usuario',
            list: 'E-Mail de Usuario',
            help: ''
        },
        password_actual: {
            label: 'Contraseña Actual',
            list: 'Contraseña Actual',
            help: 'Ingrese la contraseña actual para realizar los cambios.'
        },
        password: {
            label: 'Contraseña Nueva',
            list: 'Contraseña Nueva',
            help: 'Ingrese la contraseña nueva que desea cambiar.'
        },
        password_confirmation: {
            label: 'Confirmar Contraseña Nueva',
            list: 'Confirmar Contraseña Nueva',
            help: 'Confirme la contraseña nueva.'
        }
    }
};